import React from "react";
import PropTypes from "prop-types";
import styles from "../EstimatedBestPrice/EstimatedBestPrice.module.scss";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorWrapper}>
          <h2>Oops, there is an error!</h2>
          <button
            onClick={() => window.location.reload()}
            className={styles.tryAgainLink}
          >
            Try again?
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default ErrorBoundary;
